module.exports = __webpack_public_path__ + "img/5.16b789e3.png";